import React from 'react';
import {
  GetStartedView as BaseGetStartedView,
  GetStartedViewProps as BaseGetStartedViewProps,
} from '../../common/GetStartedView';
import { LoadingView } from '../../common/LoadingView';
import { PortalExpiredView } from './PortalExpiredView';
import { MlsAgentPlanView } from './MlsAgentPlanView';
import { useOrgOnboardingSelectContext } from '../../../contexts/OrgOnboardingSelectContext';

export type GetStartedViewProps = Omit<BaseGetStartedViewProps, 'type'>;

export const GetStartedView = (props: GetStartedViewProps) => {
  const { portalConfig } = useOrgOnboardingSelectContext();

  if (!portalConfig) {
    return <LoadingView />;
  }
  if (portalConfig.plan === 'AGENT') {
    return <MlsAgentPlanView />;
  }

  if (!portalConfig.isLandingPageActive) {
    return <PortalExpiredView />;
  }

  return <BaseGetStartedView {...props} type="org" />;
};
